import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import EkokomStatsTabs from '@/components/ekokom-stats/tabs'

function EkokomStatsView() {

    const title = 'Nastavení EKOKOM statistik'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <EkokomStatsTabs />
            </CustomPaper>
        </>
    )
}

export default EkokomStatsView
